import { EpDevPError } from "./EpDevPError";

export class EpDevPComponentError extends EpDevPError {
  public static Name = "EpDevPComponentError";
  public cause: any;
  constructor(internalLogName: string, message: string, cause: any) {
    super(internalLogName, message);
    this.name = EpDevPComponentError.Name;
    this.cause = cause;
  }
}
